import procurementScheduleEnums from 'goodeggs-purchase-orders-sdk/procurement_schedule/enums';
import moment from 'moment-timezone';

export default angular
  .module('filters.dayOfWeekDescr', [])

  .filter(
    'dayOfWeekDescr',
    () =>
      function(dayOfWeek) {
        const index = procurementScheduleEnums.daysOfWeek.indexOf(dayOfWeek);
        if (index < 0) {
          return '';
        }
        return moment()
          .day(index)
          .format('dddd');
      },
  );
